import store from "store2";
import MarketingMaterialsUpload from "./MarketingMaterialsUpload";
import SmoothieImgUpload from "./SmoothieImgUpload";
import { SiteVisitationSteps } from "../../../providers/SiteVisitationProvider";
import { GetCategoriesType } from "../../../models/_publicCall";
import Select from "react-select";
import { useState } from "react";

export const LocationMedia = ( props: { locationName: string; categoriesDB:GetCategoriesType[]; values: any; setFieldValue: any; setCurrentStep: (step: number) => void; workRunning: boolean; showLoaderForSave: boolean, jobId: string, handleChange: (arg: any) => void; }) => {
    const { locationName, values, setFieldValue, setCurrentStep, workRunning, showLoaderForSave, jobId, handleChange,categoriesDB } = props;
    const categoryOptions = categoriesDB.map((category: any) => ({ value: category.id, label: category.name }));
    const selectedActionItem = categoryOptions.find((opt: any) => opt.value === values.actionNoteCategoryId) || null;
    const selectedadditionalComments = categoryOptions.find((opt: any) => opt.value === values.additionalNoteCategoryId) || null;
    const [errors, setErrors] = useState<string[]>([]);

    const handleNext = () => {
        setErrors([]);
        const errorMessages: string[] = [];
        const hasActionItems = (values.actionItems || "").trim() !== "";
        if (hasActionItems && !values.actionNoteCategoryId) {
            errorMessages.push("Please select a category for Next Steps / Action Items.");
        }
        const hasAdditionalComments = (values.additionalComments || "").trim() !== "";
        if (hasAdditionalComments && !values.additionalNoteCategoryId) {
            errorMessages.push("Please select a category for Things of Interest with Location.");
        }
        if (errorMessages.length > 0) {
            setErrors(errorMessages);
            return;
        }
        setCurrentStep(SiteVisitationSteps.LOCATION_INFO_2);
    };
    
    return (<div className="wo-form-section mt-8">
        <header className="header">
            <h2>Location Information</h2>
        </header>
        <div className="left-icon m-4 mt-4" onClick={() => setCurrentStep(7)}>
            <i className="fa fa-arrow-left" aria-hidden="true"></i>
        </div>
        <div className="machine-wrapper">
            <p className="">
                <strong>Location Name:</strong> {locationName}
            </p>
            <SmoothieImgUpload jobId={jobId} values={values} setFieldValue={setFieldValue} />
            <MarketingMaterialsUpload jobId={jobId} values={values} setFieldValue={setFieldValue} />
            <div className=" mt-2">
                <label htmlFor="actionNoteCategoryId" className="wo-label fs-4 mb-0 fw-bold">
                    Next Steps / Action Items:
                </label>
                 <Select
                    className="react-select mt-2"
                    classNamePrefix="my-react-select"
                    name="actionNoteCategoryId"
                    id="actionNoteCategoryId"
                    value={selectedActionItem}
                    options={categoryOptions}
                    placeholder="Select Category"
                    onChange={(e: any) => {
                        const selectedValue = e?.value ?? null;
                        if (jobId) {
                            const existingData = store.get("job_id_data") || {};
                            store.set("job_id_data", {
                                ...existingData,
                                [jobId]: {
                                    ...existingData[jobId],
                                    actionNoteCategoryId: selectedValue,
                                },
                            });
                        }
                        setErrors([]);
                        handleChange({
                            target: {
                              name: "actionNoteCategoryId",
                              value: selectedValue,
                            }});
                    }}
                />
                <textarea
                    className="form-control mt-2"
                    name="actionItems"
                    id="actionItems"
                    value={values.actionItems}
                    onChange={(e) => {
                        if (jobId) {
                            const existingData = store.get("job_id_data") || {};
                            store.set("job_id_data", {
                                ...existingData,
                                [jobId]: {
                                    ...existingData[jobId],
                                    actionItems: e.target.value,
                                },
                            });
                        }
                        setErrors([]);
                        handleChange(e);
                    }}
                />
            </div>
            <div className="mt-8">
                <label htmlFor="additionalNoteCategoryId" className="wo-label fs-4 mb-0 fw-bold">
                    Things of Interest with Location:
                </label>
                  <Select
                        className="react-select mt-2"
                        classNamePrefix="my-react-select"
                        name="additionalNoteCategoryId"
                        id="additionalNoteCategoryId"
                        value={selectedadditionalComments}
                        options={categoryOptions}
                         placeholder="Select Category"
                        onChange={(e: any) => {
                            const selectedValue = e?.value ?? null;
                            if (jobId) {
                                const existingData = store.get("job_id_data") || {};
                                store.set("job_id_data", {
                                    ...existingData,
                                    [jobId]: {
                                        ...existingData[jobId],
                                        additionalNoteCategoryId: selectedValue,
                                    },
                                });
                            }
                            setErrors([]);
                            handleChange({
                                target: {
                                    name: "additionalNoteCategoryId",
                                    value: selectedValue,
                                }
                            });
                        }}
                    />
                <textarea
                    className="form-control mt-2"
                    name="additionalComments"
                    id="additionalComments"
                    value={values.additionalComments}
                    onChange={(e) => {
                        if (jobId) {
                            const existingData = store.get("job_id_data") || {};
                            store.set("job_id_data", {
                                ...existingData,
                                [jobId]: {
                                    ...existingData[jobId],
                                    additionalComments: e.target.value,
                                },
                            });
                        }
                        setErrors([]);
                        handleChange(e);
                    }}
                />
            </div>
            {errors.length > 0 && (
                <div className="alert alert-danger mt-4 mb-3 p-3 border border-danger rounded">
                    <strong>Please complete required fields for the following:</strong>
                    <ul className="mt-2 mb-0 ps-4">
                        {errors.map((err, idx) => (
                            <li key={idx}>{err}</li>
                        ))}
                    </ul>
                </div>
            )}
            <button
                className="btn btn-primary float-end mt-4"
                type="submit"
                disabled={!workRunning || showLoaderForSave}
                onClick={handleNext}
            >
                Submit <i className="fas fa-chevron-right me-2"></i>
            </button>
        </div>
    </div>)
}